import { useEffect, useRef, useState } from "react";

const useResponsiveColumnWidth = (numColumns: number) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [columnWidth, setColumnWidth] = useState(60); // fallback default

  useEffect(() => {
    const calculateWidth = () => {
      if (containerRef.current && numColumns > 0) {
        const parentWidth = containerRef.current.offsetWidth;
        const width = parentWidth / numColumns;
        setColumnWidth(width);
      }
    };

    calculateWidth();
    window.addEventListener("resize", calculateWidth);
    return () => window.removeEventListener("resize", calculateWidth);
  }, [numColumns]);

  return { columnWidth, containerRef };
};

export default useResponsiveColumnWidth;
